import { createContext, useRef, useEffect, useState } from 'react';
// import { createBlockchainTable, createSqlTable } from './services/sql/sqlHelpers';

export const appContext = createContext({
  files: [] as CustomFile[],
  setFiles: (() => {}) as React.Dispatch<React.SetStateAction<CustomFile[]>>,
  validateState: false,
  setValidateState: (() => {}) as React.Dispatch<React.SetStateAction<boolean>>,
  validationComplete: false,
  setValidationComplete: (() => {}) as React.Dispatch<React.SetStateAction<boolean>>,
  validationStatus: '',
  setValidationStatus: (() => {}) as React.Dispatch<React.SetStateAction<string>>,
  deletingFile: false,
  setDeletingFile: (() => {}) as React.Dispatch<React.SetStateAction<boolean>>,
  validationLoader: false,
  setValidationLoader: (() => {}) as React.Dispatch<React.SetStateAction<boolean>>,
  configHistory: {} as ConfigHistory,
  setConfigHistory: (() => {}) as React.Dispatch<React.SetStateAction<ConfigHistory>>,
  configLatest: {} as ConfigHistory,
  setConfigLatest: (() => {}) as React.Dispatch<React.SetStateAction<ConfigHistory>>,
  validatingFile: '',
  setValidatingFile: (() => {}) as React.Dispatch<React.SetStateAction<string>>,
  uploadLimitReached: false,
  setUploadLimitReached: (() => {}) as React.Dispatch<React.SetStateAction<boolean>>,
  JSONfileCombined: false,
  setJSONfileCombined: (() => {}) as React.Dispatch<React.SetStateAction<boolean>>,
});

const MDS = (window as any).MDS;
// TODO utkommenterat
// TODO Nathalie ta bort historyData om det funkar
const AppProvider = ({ children }: IContextProps) => {
  const [files, setFiles] = useState<CustomFile[]>([]); // Array of selected files
  const [validateState, setValidateState] = useState(false); // Indicates if validation is ongoing
  const [validationComplete, setValidationComplete] = useState(false); // Validation progress complete
  const [validationStatus, setValidationStatus] = useState(''); // Validation progress complete
  const [deletingFile, setDeletingFile] = useState(false); // Validation progress complete
  const [validationLoader, setValidationLoader] = useState(false); // Loader state for validation process
  // const [historyData, setHistoryData] = useState<any>();
  const [validatingFile, setValidatingFile] = useState<string>(''); // Currently validating file
  const [uploadLimitReached, setUploadLimitReached] = useState(false);
  const [JSONfileCombined, setJSONfileCombined] = useState(false);

  // Configuration states for history and latest history views
  const [configHistory, setConfigHistory] = useState<ConfigHistory>({
    sortProperty: '',
    sortOrder: '',
    filterProperty: '',
    searchTerm: '',
  });
  const [configLatest, setConfigLatest] = useState<ConfigHistory>({
    sortProperty: '',
    sortOrder: '',
    filterProperty: '',
    searchTerm: '',
  });

  // Ref to prevent redundant initialization logic in `useEffect`
  const loaded = useRef(false);

  // Effect to initialize database tables when the app first loads
  // useEffect(() => {
  //   if (!loaded.current) {
  //     loaded.current = true;
  //     MDS.init(async (msg: any) => {
  //       if (msg.event === 'inited') {
  //         // createSqlTable();
  //         // createBlockchainTable();
  //       }
  //       if (msg.event == 'MDS_PENDING') {
  //         window.dispatchEvent(new CustomEvent('MDS_PENDING', { detail: msg }));
  //       }
  //     });
  //   }
  // }, [loaded]);

  return (
    <appContext.Provider
      value={{
        files,
        setFiles,
        validateState,
        setValidateState,
        validationComplete,
        setValidationComplete,
        validationStatus,
        setValidationStatus,
        deletingFile,
        setDeletingFile,
        validationLoader,
        setValidationLoader,
        configHistory,
        setConfigHistory,
        configLatest,
        setConfigLatest,
        validatingFile,
        setValidatingFile,
        uploadLimitReached,
        setUploadLimitReached,
        JSONfileCombined,
        setJSONfileCombined,
      }}
    >
      {children}
    </appContext.Provider>
  );
};

export default AppProvider;
